import qs from 'qs';

import HttpCodes from './http-codes';
import axios from './axios';
// eslint-disable-next-line import/no-cycle
import store from '../store';

const authConfig = {
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
};

function errHnd(error, handler) {
  if (error.message === 'Network Error') {
    // network error
    alert('Произошла ошибка сервера, попробуйте позже'); // eslint-disable-line
    // window.location.reload();
  } else {
    if (error.response.status && error.response.status === 401) {
      store.commit('logout');
    }
    if (typeof handler === 'function') {
      handler(error);
    }
  }
}

export default {
  http_codes: HttpCodes,

  getLayout: async (errHandler) => new Promise((resolve) => axios
    .get('/api/v3/pages/layout')
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  search: async (params, errHandler) => new Promise((resolve) => axios
    .get('/api/v2/search')
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  sendAuth: async (params, errHandler) => new Promise((resolve) => axios
    .post('/api/v2/auth', qs.stringify(params), authConfig)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getCabinet: async (errHandler) => new Promise((resolve) => axios
    .get('/api/v2/pages/cabinet')
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getOrders: async (params, errHandler) => new Promise((resolve) => axios
    .get('/api/v3/users/me/orders', { params })
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getVideos: async (params, errHandler) => new Promise((resolve) => axios
    .get('/api/v3/users/me/videos', { params })
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getOrder: async (id, lang, errHandler) => new Promise((resolve) => axios
    .get(`/api/v3/users/me/orders/${id}?lang=${lang}`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  deleteOrder: async (id, errHandler) => new Promise((resolve) => axios
    .delete(`/api/v2/frame/order/${id}`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  deleteTicket: async (id, ticketId, errHandler) => new Promise((resolve) => axios
    .delete(`/api/v2/frame/order/${id}/ticket/${ticketId}`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  returnTicket: async (orderId, ticketId, slug, type, errHandler) => new Promise((resolve) => axios
    .delete(`/api/v3/users/me/orders/${orderId}/${slug}/${ticketId}?type=${type}`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  returnOrder: async (orderId, type, errHandler) => new Promise((resolve) => axios
    .delete(`/api/v3/users/me/orders/${orderId}?type=${type}`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getPayments: async (params, errHandler) => new Promise((resolve) => axios
    .get('/api/v2/frame/payment', { params })
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  acceptOrder: async (id, params, errHandler) => new Promise((resolve) => axios
    .put(`/api/v2/frame/order/${id}?${qs.stringify(params)}`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getErip: async (id, errHandler) => new Promise((resolve) => axios
    .get(`/api/v2/frame/payment/erip?id=${id}`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  payment: {
    // /api/v2/frame/payment/tokenization_params
    tokenization_params: async (params = {}, errorCallback) => new Promise((resolve) => axios
      .get('/api/v2/frame/payment/tokenization_params', params)
      .then((response) => resolve(response.data))
      .catch((e) => errHnd(e, errorCallback))),
  },

  /** PASSPORTS
   * * get - доступные к оформлению подписки
   */
  allSubscribes: async (params, errorCallback) => new Promise((resolve) => axios
    .get('/api/v3/subscribes', params)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errorCallback))),
  /** PASSPORTS
   * * get - список паспортов
   * * post  - добавить паспорт
   * * put - изменить паспорт
   * * delete - удалить паспорт
   */
  passports: {
    get: async (params, errorCallback) => new Promise((resolve) => axios
      .get('/api/v3/users/me/passports', params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
    post: async (params, errorCallback) => new Promise((resolve) => axios
      .post('/api/v3/users/me/passports', params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
    put: async (id, params, errorCallback) => new Promise((resolve) => axios
      .put(`/api/v3/users/me/passports/${id}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
    del: async (id, params, errorCallback) => new Promise((resolve) => axios
      .delete(`/api/v3/users/me/passports/${id}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
  },
  /** ADDRESSES
   * * get - список адресов
   * * post - добавить адрес
   * * put - измсенить адрес
   * * delete  - удалить адрес
   */
  addresses: {
    get: async (params, errorCallback) => new Promise((resolve) => axios
      .get('/api/v3/users/me/addresses', params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
    post: async (params, errorCallback) => new Promise((resolve) => axios
      .post('/api/v3/users/me/addresses', params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
    put: async (id, params, errorCallback) => new Promise((resolve) => axios
      .put(`/api/v3/users/me/addresses/${id}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
    del: async (id, params, errorCallback) => new Promise((resolve) => axios
      .delete(`/api/v3/users/me/addresses/${id}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
  },

  /** SUBSCRIBES
   * * get - список подписок
   * * post - оформить подписку
   * * put - изменить подписку
   */
  subscribes: {
    get: async (params, errorCallback) => new Promise((resolve) => axios
      .get('/api/v3/users/me/subscribes', params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
    post: async (params, errorCallback) => new Promise((resolve) => axios
      .post('/api/v3/users/me/subscribes', params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
    put: async (id, params, errorCallback) => new Promise((resolve) => axios
      .put(`/api/v3/users/me/subscribes/${id}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
    del: async (id, params, errorCallback) => new Promise((resolve) => axios
      .delete(`/api/v3/users/me/subscribes/${id}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
  },

  // /api/v2/users/me/cards
  cards: {
    put: async (params, errorCallback) => new Promise((resolve) => axios
      .put('/api/v2/users/me/cards', params)
      .then((response) => resolve(response.data))
      .catch((error) => errHnd(error, errorCallback))),
  },

  getUserInfo: async (errHandler) => new Promise((resolve) => axios
    .get('/api/v2/users/me')
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getCities: async (lang, errHandler) => new Promise((resolve) => axios
    .get(`/api/v2/cities?lang=${lang}`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  setProfile: async (params, errHandler) => new Promise((resolve) => axios
    .put('/api/v2/users/me/profile', params)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getTransactions: async (params, errHandler) => new Promise((resolve) => axios
    .get('/api/v2/users/me/transactions', { params })
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getPromotions: async (params, errHandler) => new Promise((resolve) => axios
    .get('/api/v2/users/me/coupons', { params })
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  activatePromocode: async (params, errHandler) => new Promise((resolve) => axios
    .post('/api/v2/promocodes/activate', { params })
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  setEarlyCode: async (params, errHandler) => new Promise((resolve) => axios
    .post('/api/v2/users/me/earlybooking', params)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getCards: async (errHandler) => new Promise((resolve) => axios
    .get('/api/v2/users/me/cards')
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  getBindingCards: async (errHandler) => new Promise((resolve) => axios
    .get('/api/v2/users/me/bindings-cards')
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  deleteCard: async (id, errHandler) => new Promise((resolve) => axios
    .delete(`/api/v2/users/me/cards/${id}`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  setERStatus: async (id, params, errHandler) => new Promise((resolve) => axios
    .put(`/api/v3/integration/train/order/${id}/remote-checkin`, params)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  setERStatusTicket: async (id, trainId, params, errHandler) => new Promise((resolve) => axios
    .put(`/api/v3/integration/train/order/${id}/trains/${trainId}/remote-checkin`, params)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  returnInfo: async (id, errHandler) => new Promise((resolve) => axios
    .get(`/api/v3/users/me/orders/${id}/return-info`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  returnTicketInfo: async (id, type, ticketId, errHandler) => new Promise((resolve) => axios
    .get(`/api/v3/users/me/orders/${id}/${type}/${ticketId}/return-info`)
    .then((response) => resolve(response.data))
    .catch((error) => errHnd(error, errHandler))),

  // про привязку карты и про привязку билета
  assignTicket: async (code, errHandler) => new Promise((resolve, reject) => axios
    .post('/api/v2/users/me/assign/ticket', {
      code,
    })
    .then((response) => resolve(response.data))
    .catch((error) => {
      errHnd(error, errHandler);
      reject(error);
    })),

  cardCode(code) { return (!code ? this.newCardCode() : this.assignCardCode(code)); },

  newCardCode: async (errHandler) => new Promise((resolve, reject) => axios
    .post('/api/v2/users/me/cardcode')
    .then((response) => resolve(response.data))
    .catch((error) => {
      errHnd(error, errHandler);
      reject(error);
    })),
  assignCardCode: async (code, errHandler) => new Promise((resolve, reject) => axios
    .post('/api/v2/users/me/cardcode', {
      card_code: code,
    })
    .then((response) => resolve(response.data))
    .catch((error) => {
      errHnd(error, errHandler);
      reject(error);
    })),

  deleteCardCode: async (errHandler) => new Promise((resolve, reject) => axios
    .delete('/api/v2/users/me/cardcode')
    .then((response) => resolve(response.data))
    .catch((error) => {
      errHnd(error, errHandler);
      reject(error);
    })),
};
